import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { IndependentIraUser, IraUser } from 'services/requests';
import { useQueryDateRange } from 'hooks/routes';
import { formatInputDateForBE } from 'utils';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

export const useGenerateAccountStatement = (user: IndependentIraUser | IraUser) => {
  const [{ from: fromQuery, to: toQuery }] = useQueryDateRange();

  const startDateString = fromQuery ? formatInputDateForBE(fromQuery) : '';
  const endDateString = toQuery ? formatInputDateForBE(toQuery) : '';
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const payload = {
    userProfileId: user.id,
    startDate: startDateString,
    endDate: endDateString,
    timeZoneId,
  };

  const fileName = `${user.custodianType} FBO ${user.firstName} ${user.lastName}, ${user.profileType} ${user.accountNumber}.pdf`;

  const mutate = async () => {
    const { data } = await api.generateAccountStatement(payload);
    return data;
  };

  return useMutation<Blob, AxiosError>(mutate, {
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showInfoToast(Messages.successGenerateAccountStatement);
    },
  });
};
